import React, { useState, useEffect } from 'react';
import { Plus, Edit2, Trash2, X, User, Eye } from 'lucide-react';
import {participantService} from '../services/participantService';
import CustomAlert from '../components/CustomAlert';
import useCustomAlert from '../hooks/useCustomAlert';

const styles = `
.minhas-criancas-page {
  min-height: 100vh;
  background-color: #f9fafb;
  padding: 3rem 1rem;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
}

.custom-select-wrapper {
  position: relative;
}

.custom-select {
  width: 100%;
  padding: 0.875rem 2.5rem 0.875rem 1rem;
  border: 2px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 1rem;
  color: #374151;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.custom-select:hover {
  border-color: #5A9C9C;
}

.custom-select:focus {
  outline: none;
  border-color: #4A8080;
  box-shadow: 0 0 0 3px rgba(90, 156, 156, 0.1);
}

.select-arrow {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #6b7280;
  transition: transform 0.3s ease;
}

.custom-select:focus ~ .select-arrow {
  transform: translateY(-50%) rotate(180deg);
  color: #4A8080;
}

.custom-select option {
  padding: 0.75rem;
  font-size: 1rem;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3rem;
}

.page-title {
  font-size: 2.5rem;
  color: #5A9C9C;
  font-weight: 300;
  margin: 0;
}

.add-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.add-btn:hover {
  background-color: #3A6666;
}

.children-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
}

.child-card {
  background-color: white;
  border-radius: 0.5rem;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.child-card:hover {
  transform: translateY(-5px);
}

.child-card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.child-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #e0f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4A8080;
}

.child-name {
  font-size: 1.5rem;
  color: #4A8080;
  margin: 0;
  flex: 1;
}

.child-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.info-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.95rem;
}

.info-label {
  color: #6b7280;
  font-weight: 500;
}

.info-value {
  color: #374151;
}

.child-actions {
  display: flex;
  gap: 0.75rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}

.action-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.view-btn {
  background-color: #f0f9f9;
  color: #4A8080;
  border: 1px solid #4A8080;
}

.view-btn:hover {
  background-color: #e0f2f2;
}

.edit-btn {
  background-color: #fff7ed;
  color: #ea580c;
  border: 1px solid #ea580c;
}

.edit-btn:hover {
  background-color: #ffedd5;
}

.delete-btn {
  background-color: #fee2e2;
  color: #dc2626;
  border: 1px solid #dc2626;
}

.delete-btn:hover {
  background-color: #fecaca;
}

.details-modal-body {
  padding: 2rem;
}

.details-section {
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e5e7eb;
}

.details-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.details-section-title {
  font-size: 1.25rem;
  color: #5A9C9C;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.detail-item.full-width {
  grid-column: span 2;
}

.detail-item-label {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.detail-item-value {
  font-size: 1rem;
  color: #374151;
  background-color: #f9fafb;
  padding: 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid #e5e7eb;
}

.detail-item-value.empty {
  color: #9ca3af;
  font-style: italic;
}

.pessoas-autorizadas-section {
  display: grid;
  gap: 1rem;
  margin-top: 1rem;
}

.pessoa-autorizada-card {
  background-color: #f0f9f9;
  border: 1px solid #5A9C9C;
  border-radius: 0.5rem;
  padding: 1.5rem;
}

.pessoa-autorizada-title {
  font-weight: 700;
  color: #4A8080;
  margin-bottom: 1rem;
  font-size: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #5A9C9C;
}

.pessoa-autorizada-details {
  display: grid;
  gap: 0.75rem;
}

.close-details-btn {
  width: 100%;
  padding: 1rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 2rem;
}

.close-details-btn:hover {
  background-color: #3A6666;
}

@media (max-width: 768px) {
  .details-grid {
    grid-template-columns: 1fr;
  }

  .detail-item.full-width {
    grid-column: span 1;
  }
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.empty-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  background-color: #f0f9f9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5A9C9C;
}

.empty-title {
  font-size: 1.5rem;
  color: #4A8080;
  margin-bottom: 0.5rem;
}

.empty-text {
  color: #6b7280;
  margin-bottom: 2rem;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: white;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 0.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.modal-header {
  background-color: #4A8080;
  color: white;
  padding: 2rem;
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  font-size: 1.75rem;
  margin: 0;
  font-weight: 300;
}

.modal-close-btn {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0.5rem;
  transition: opacity 0.3s;
}

.modal-close-btn:hover {
  opacity: 0.7;
}

.modal-body {
  padding: 2rem;
}

.form-section {
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e5e7eb;
}

.form-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.section-title {
  font-size: 1.25rem;
  color: #5A9C9C;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group.full-width {
  grid-column: span 2;
}

.form-label {
  color: #374151;
  font-size: 0.95rem;
  font-weight: 500;
}

.form-input,
.form-textarea {
  padding: 0.875rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-family: inherit;
  transition: border-color 0.3s;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #5A9C9C;
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

.pessoas-autorizadas-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.pessoa-autorizada-item {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  padding: 1rem;
}

.pessoa-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.pessoa-numero {
  font-weight: 600;
  color: #4A8080;
}

.remove-pessoa-btn {
  background: none;
  border: none;
  color: #dc2626;
  cursor: pointer;
  padding: 0.25rem;
  transition: opacity 0.3s;
}

.remove-pessoa-btn:hover {
  opacity: 0.7;
}

.add-pessoa-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background-color: #f0f9f9;
  color: #4A8080;
  border: 1px dashed #4A8080;
  border-radius: 0.375rem;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 1rem;
}

.add-pessoa-btn:hover {
  background-color: #e0f2f2;
}

.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;
}

.cancel-btn {
  padding: 1rem 2rem;
  background-color: white;
  color: #6b7280;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.cancel-btn:hover {
  background-color: #f9fafb;
}

.submit-btn {
  padding: 1rem 2rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-btn:hover {
  background-color: #3A6666;
}

.submit-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.error-message {
  background-color: #fee2e2;
  border: 1px solid #fecaca;
  color: #dc2626;
  padding: 1rem;
  border-radius: 0.375rem;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}

.loading {
  text-align: center;
  padding: 3rem;
  color: #6b7280;
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  .page-title {
    font-size: 2rem;
  }

  .children-grid {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .form-group.full-width {
    grid-column: span 1;
  }

  .form-actions {
    flex-direction: column;
  }

  .cancel-btn,
  .submit-btn {
    width: 100%;
  }
}
`;

export default function MeusParticipantesPage() {
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [viewingChild, setViewingChild] = useState(null);
  const [editingParticipant, setEditingParticipant] = useState(null);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { alertProps, showSuccess, showError } = useCustomAlert();
  const [formData, setFormData] = useState({
    type: 'Child',
    nome: '',
    dataNascimento: '',
    cartaoCidadao: '',
    estabelecimentoEnsino: '',
    validoAte: '',
    nif: '',
    alergias: '',
    alimentosProibidos: '',
    medicacaoFrequente: '',
    necessidadesEducativas: '',
    outrosAspectos: '',
    pessoasAutorizadas: []
  });

  useEffect(() => {
    loadParticipants();
  }, []);

  const handleViewDetails = (child) => {
    setViewingChild(child);
    setDetailsModalOpen(true);
  };

  const handleCloseDetailsModal = () => {
    setDetailsModalOpen(false);
    setViewingChild(null);
  };

  const loadParticipants = async () => {
    try {
      setLoading(true);
      const data = await participantService.getParticipants();
      setParticipants(data);
    } catch (err) {
      console.error('Erro ao carregar participantes:', err);
      setError('Erro ao carregar a lista de participantes');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (participant = null) => {
  if (participant) {
    let participantType = participant.type;
    if (participant.type === 0 || participant.type === 1) {
      participantType = participant.type === 0 ? 'Child' : 'Adult';
    }

    setEditingParticipant(participant);
    setFormData({
      type: participantType, 
      nome: participant.nome,
      dataNascimento: participant.dataNascimento.split('T')[0],
      cartaoCidadao: participant.cartaoCidadao,
      estabelecimentoEnsino: participant.estabelecimentoEnsino || '',
      validoAte: participant.validoAte.split('T')[0],
      nif: participant.nif,
      alergias: participant.alergias || '',
      alimentosProibidos: participant.alimentosProibidos || '',
      medicacaoFrequente: participant.medicacaoFrequente || '',
      necessidadesEducativas: participant.necessidadesEducativas || '',
      outrosAspectos: participant.outrosAspectos || '',
      pessoasAutorizadas: participant.pessoasAutorizadas || []
    });
  } else {
    setEditingParticipant(null);
    setFormData({
      type: 'Child',
      nome: '',
      dataNascimento: '',
      cartaoCidadao: '',
      estabelecimentoEnsino: '',
      validoAte: '',
      nif: '',
      alergias: '',
      alimentosProibidos: '',
      medicacaoFrequente: '',
      necessidadesEducativas: '',
      outrosAspectos: '',
      pessoasAutorizadas: []
    });
  }
  setShowModal(true);
};

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingParticipant(null);
    setError('');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (name === 'type') {
      if (value === 'Adult') {
        setFormData(prev => ({
          ...prev,
          estabelecimentoEnsino: '',
          necessidadesEducativas: '',
          pessoasAutorizadas: []
        }));
      }
    }
  };

  const handleAddPessoa = () => {
    setFormData({
      ...formData,
      pessoasAutorizadas: [
        ...formData.pessoasAutorizadas,
        { nome: '', cartaoCidadao: '', telefone: '' }
      ]
    });
  };

  const handleRemovePessoa = (index) => {
    const newPessoas = formData.pessoasAutorizadas.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      pessoasAutorizadas: newPessoas
    });
  };

  const handlePessoaChange = (index, field, value) => {
    const newPessoas = [...formData.pessoasAutorizadas];
    newPessoas[index][field] = value;
    setFormData({
      ...formData,
      pessoasAutorizadas: newPessoas
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  setSubmitting(true);

  try {
    const submitData = {
      ...formData,
      alergias: formData.alergias || null,
      alimentosProibidos: formData.alimentosProibidos || null,
      medicacaoFrequente: formData.medicacaoFrequente || null,
      necessidadesEducativas: formData.necessidadesEducativas || null,
      outrosAspectos: formData.outrosAspectos || null,
      estabelecimentoEnsino: formData.estabelecimentoEnsino || null,
      pessoasAutorizadas: formData.pessoasAutorizadas || []
    };

    if (editingParticipant) {
      await participantService.updateParticipant(editingParticipant.id, submitData);
      showSuccess('Participante atualizado com sucesso!');
    } else {
      await participantService.createParticipant(submitData);
      showSuccess('Participante cadastrado com sucesso!');
    }
    
    handleCloseModal();
    loadParticipants();
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message || 'Erro ao salvar os dados do participante';
    setError(errorMessage);
    console.error('Erro detalhado:', err.response?.data);
  } finally {
    setSubmitting(false);
  }
};

  const handleDelete = async (id, nome) => {
    if (!window.confirm(`Tem certeza que deseja excluir ${nome}?`)) {
      return;
    }

    try {
      await participantService.deleteParticipant(id);
      showSuccess('Participante excluí­do com sucesso!');
      loadParticipants();
    } catch (err) {
      showError('Erro ao excluir criança');
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-PT');
  };

  const calculateAge = (birthDate) => {
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    
    return age;
  };

  if (loading) {
    return (
      <>
        <style>{styles}</style>
        <div className="minhas-criancas-page">
          <div className="container">
            <div className="loading">Carregando...</div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{styles}</style>
      <div className="minhas-criancas-page">
        <div className="container">
          <div className="page-header">
            <h1 className="page-title">Meus Participantes</h1>
            <button className="add-btn" onClick={() => handleOpenModal()}>
              <Plus size={20} />
              Adicionar Participante
            </button>
          </div>

          {participants.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">
                <User size={40} />
              </div>
              <h2 className="empty-title">Nenhum participante cadastrado</h2>
              <p className="empty-text">
                Adicione as informações dos seus participantes para facilitar os agendamentos
              </p>
              <button className="add-btn" onClick={() => handleOpenModal()}>
                <Plus size={20} />
                Adicionar Primeiro Participante
              </button>
            </div>
          ) : (
            <div className="children-grid">
              {participants.map((child) => (
                <div key={child.id} className="child-card">
                  <div className="child-card-header">
                    <div className="child-avatar">
                      <User size={30} />
                    </div>
                    <h3 className="child-name">{child.nome}</h3>
                  </div>

                  <div className="child-info">
                    <div className="info-row">
                      <span className="info-label">Idade:</span>
                      <span className="info-value">{calculateAge(child.dataNascimento)} anos</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Data Nascimento:</span>
                      <span className="info-value">{formatDate(child.dataNascimento)}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">NIF:</span>
                      <span className="info-value">{child.nif}</span>
                    </div>
                    {(child.type === 0 || child.type === 'Child') && child.estabelecimentoEnsino && (
                      <div className="info-row">
                        <span className="info-label">Estabelecimento:</span>
                        <span className="info-value">{child.estabelecimentoEnsino}</span>
                      </div>
                    )}
                  </div>

                  <div className="child-actions">
                    <button className="action-btn view-btn" onClick={() => handleViewDetails(child)}>
                      <Eye size={16} />
                      Ver Detalhes
                    </button>
                    <button className="action-btn edit-btn" onClick={() => handleOpenModal(child)}>
                      <Edit2 size={16} />
                      Editar
                    </button>
                    <button className="action-btn delete-btn" onClick={() => handleDelete(child.id, child.nome)}>
                      <Trash2 size={16} />
                      Excluir
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {detailsModalOpen && viewingChild && (
          <div className="modal-overlay" onClick={handleCloseDetailsModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2 className="modal-title">
                  Detalhes - {viewingChild.nome}
                </h2>
                <button className="modal-close-btn" onClick={handleCloseDetailsModal}>
                  <X size={24} />
                </button>
              </div>

              <div className="details-modal-body">
                <div className="details-section">
                  <h3 className="details-section-title">Informações Básicas</h3>
                  <div className="details-grid">
                    <div className="detail-item">
                      <span className="detail-item-label">Nome Completo</span>
                      <span className="detail-item-value">{viewingChild.nome}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-item-label">Data de Nascimento</span>
                      <span className="detail-item-value">
                        {formatDate(viewingChild.dataNascimento)} ({calculateAge(viewingChild.dataNascimento)} anos)
                      </span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-item-label">Nº de Cartão de Cidadão</span>
                      <span className="detail-item-value">{viewingChild.cartaoCidadao}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-item-label">Válido até</span>
                      <span className="detail-item-value">{formatDate(viewingChild.validoAte)}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-item-label">NIF</span>
                      <span className="detail-item-value">{viewingChild.nif}</span>
                    </div>
                    {(viewingChild.type === 0 || viewingChild.type === 'Child') && viewingChild.estabelecimentoEnsino && (
                      <div className="detail-item">
                        <span className="detail-item-label">Estabelecimento de Ensino</span>
                        <span className="detail-item-value">{viewingChild.estabelecimentoEnsino}</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="details-section">
                  <h3 className="details-section-title">Sobre</h3>
                  <div className="details-grid">
                    <div className="detail-item full-width">
                      <span className="detail-item-label">Alergias/Doenças</span>
                      <span className={`detail-item-value ${!viewingChild.alergias ? 'empty' : ''}`}>
                        {viewingChild.alergias || 'Não informado'}
                      </span>
                    </div>
                    <div className="detail-item full-width">
                      <span className="detail-item-label">Alimentos Proibidos</span>
                      <span className={`detail-item-value ${!viewingChild.alimentosProibidos ? 'empty' : ''}`}>
                        {viewingChild.alimentosProibidos || 'Não informado'}
                      </span>
                    </div>
                    <div className="detail-item full-width">
                      <span className="detail-item-label">Medicação Frequente</span>
                      <span className={`detail-item-value ${!viewingChild.medicacaoFrequente ? 'empty' : ''}`}>
                        {viewingChild.medicacaoFrequente || 'Não informado'}
                      </span>
                    </div>
                    <div className="detail-item full-width">
                      <span className="detail-item-label">Necessidades Educativas Especiais</span>
                      <span className={`detail-item-value ${!viewingChild.necessidadesEducativas ? 'empty' : ''}`}>
                        {viewingChild.necessidadesEducativas || 'Não informado'}
                      </span>
                    </div>
                    <div className="detail-item full-width">
                      <span className="detail-item-label">Outros Aspetos Relevantes</span>
                      <span className={`detail-item-value ${!viewingChild.outrosAspectos ? 'empty' : ''}`}>
                        {viewingChild.outrosAspectos || 'Não informado'}
                      </span>
                    </div>
                  </div>
                </div>

                {viewingChild.pessoasAutorizadas && viewingChild.pessoasAutorizadas.length > 0 && (
                  <div className="details-section">
                    <h3 className="details-section-title">
                      Pessoas Autorizadas a Recolher a Criança
                    </h3>
                    <div className="pessoas-autorizadas-section">
                      {viewingChild.pessoasAutorizadas.map((pessoa, index) => (
                        <div key={index} className="pessoa-autorizada-card">
                          <div className="pessoa-autorizada-title">
                            Pessoa Autorizada {index + 1}
                          </div>
                          <div className="pessoa-autorizada-details">
                            <div className="detail-item">
                              <span className="detail-item-label">Nome</span>
                              <span className="detail-item-value">{pessoa.nome}</span>
                            </div>
                            <div className="detail-item">
                              <span className="detail-item-label">Nº de Cartão de Cidadão</span>
                              <span className="detail-item-value">{pessoa.cartaoCidadao}</span>
                            </div>
                            <div className="detail-item">
                              <span className="detail-item-label">Telefone</span>
                              <span className="detail-item-value">{pessoa.telefone}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <button className="close-details-btn" onClick={handleCloseDetailsModal}>
                  Fechar
                </button>
              </div>
            </div>
          </div>
        )}

        {showModal && (
          <div className="modal-overlay" onClick={handleCloseModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2 className="modal-title">
                  {editingParticipant ? 'Editar Participante' : 'Adicionar Participante'}
                </h2>
                <button className="modal-close-btn" onClick={handleCloseModal}>
                  <X size={24} />
                </button>
              </div>

              <div className="modal-body">
                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleSubmit}>
                  <div className="form-section">
                    <div className="form-group">
                      <label className="form-label">Tipo de Participante *</label>
                      <div className="custom-select-wrapper">
                        <select 
                          name="type" 
                          value={formData.type} 
                          onChange={handleChange}
                          className="custom-select"
                          required
                        >
                          <option value="">Selecione o tipo...</option>
                          <option value="Child">Criança</option>
                          <option value="Adult">Adulto</option>
                        </select>
                        <div className="select-arrow">
                          <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                            <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                        </div>
                      </div>
                    </div>

                    
                    <div className="form-group full-width">
                      <label className="form-label">Nome Completo *</label>
                      <input
                        type="text"
                        name="nome"
                        className="form-input"
                        value={formData.nome}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Data de Nascimento *</label>
                        <input
                          type="date"
                          name="dataNascimento"
                          className="form-input"
                          value={formData.dataNascimento}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label className="form-label">Nº Cartão de Cidadão *</label>
                        <input
                          type="text"
                          name="cartaoCidadao"
                          className="form-input"
                          value={formData.cartaoCidadao}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      {(formData.type === 'Child' || formData.type === 0) && (
                        <div className="form-group">
                          <label className="form-label">Estabelecimento de Ensino *</label>
                          <input
                            type="text"
                            name="estabelecimentoEnsino"
                            className="form-input"
                            value={formData.estabelecimentoEnsino}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      )}

                      <div className="form-group">
                        <label className="form-label">Válido Até *</label>
                        <input
                          type="date"
                          name="validoAte"
                          className="form-input"
                          value={formData.validoAte}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">NIF *</label>
                      <input
                        type="text"
                        name="nif"
                        className="form-input"
                        value={formData.nif}
                        onChange={handleChange}
                        maxLength="9"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-section">
                    <h3 className="section-title">Informações</h3>

                    <div className="form-group">
                      <label className="form-label">Alergias/doenças</label>
                      <input
                        type="text"
                        name="alergias"
                        className="form-input"
                        value={formData.alergias}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Alimentos Proibidos</label>
                      <input
                        type="text"
                        name="alimentosProibidos"
                        className="form-input"
                        value={formData.alimentosProibidos}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Medicação frequente</label>
                      <input
                        type="text"
                        name="medicacaoFrequente"
                        className="form-input"
                        value={formData.medicacaoFrequente}
                        onChange={handleChange}
                      />
                    </div>

                    {(formData.type === 'Child' || formData.type === 0) && (
                      <div className="form-group">
                        <label className="form-label">Necessidades educativas especiais</label>
                        <input
                          type="text"
                          name="necessidadesEducativas"
                          className="form-input"
                          value={formData.necessidadesEducativas}
                          onChange={handleChange}
                        />
                      </div>
                    )}

                    <div className="form-group">
                      <label className="form-label">Outros aspetos relevantes (medos; dificuldades)</label>
                      <textarea
                        name="outrosAspectos"
                        className="form-textarea"
                        value={formData.outrosAspectos}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  
                  {(formData.type === 'Child' || formData.type === 0) && (
                    <div className="form-section">
                      <h3 className="section-title">Pessoas autorizadas a recolher a criança</h3>
                      
                      <div className="pessoas-autorizadas-list">
                        {formData.pessoasAutorizadas.map((pessoa, index) => (
                          <div key={index} className="pessoa-autorizada-item">
                            <div className="pessoa-header">
                              <span className="pessoa-numero">Pessoa {index + 1}</span>
                              <button
                                type="button"
                                className="remove-pessoa-btn"
                                onClick={() => handleRemovePessoa(index)}
                              >
                                <Trash2 size={18} />
                              </button>
                            </div>

                            <div className="form-group">
                              <label className="form-label">Nome</label>
                              <input
                                type="text"
                                className="form-input"
                                value={pessoa.nome}
                                onChange={(e) => handlePessoaChange(index, 'nome', e.target.value)}
                              />
                            </div>

                            <div className="form-row">
                              <div className="form-group">
                                <label className="form-label">Nº de Cartão de Cidadao</label>
                                <input
                                  type="text"
                                  className="form-input"
                                  value={pessoa.cartaoCidadao}
                                  onChange={(e) => handlePessoaChange(index, 'cartaoCidadao', e.target.value)}
                                />
                              </div>

                              <div className="form-group">
                                <label className="form-label">Telefone</label>
                                <input
                                  type="tel"
                                  className="form-input"
                                  value={pessoa.telefone}
                                  onChange={(e) => handlePessoaChange(index, 'telefone', e.target.value)}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    

                      <button
                        type="button"
                        className="add-pessoa-btn"
                        onClick={handleAddPessoa}
                      >
                        <Plus size={18} />
                        Adicionar Pessoa Autorizada
                      </button>
                    </div>

                  )}

                  <div className="form-actions">
                    <button
                      type="button"
                      className="cancel-btn"
                      onClick={handleCloseModal}
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="submit-btn"
                      disabled={submitting}
                    >
                      {submitting ? 'Salvando...' : editingParticipant ? 'Atualizar' : 'Cadastrar'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
        <CustomAlert {...alertProps} />
      </div>
    </>
  );
}